import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class CompassCategoryRating extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'CompassCategoryRating'
  // Define default properties here
  static instanceDefaults () {
    return {
      compassId: null,
      rating: 0,
      categoryId: null,
      frameworksCategoryId: null,
      compassUserRatingId: null,
      compassCategoryId: null,
    }
  }
}
const servicePath = 'compass-categories-ratings'
const servicePlugin = makeServicePlugin({
  Model: CompassCategoryRating,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
